import { Editable, Slate, withReact } from 'slate-react'
import { compose } from 'ramda'
import { createEditor } from 'slate'
import { withHistory } from 'slate-history'
import React from 'react'

import { deserializeMarkdown } from '../_serializers/markdownDeserializer'
import { renderElement, renderLeaf } from '../_plugins/plugins'
import { serializeMarkdown } from '../_serializers/markdownSerializer'
import { useEditorKeydown } from '../_plugins/keydowns'
import { useUploadRequest } from '../../../../utils/hooks/uploadV2'
import EditorContext from '../EditorContext'
import ImagePlugin from '../_plugins/ImagePlugin'
import InterpolationPlugin from '../_plugins/InterpolationPlugin'
import LinkPlugin from '../_plugins/LinkPlugin'
import MarkdownControlBar from './MarkdownControlBar'
import Panel from '../../../kiti/components/structure/Panel'
import Separator from '../../../kiti/components/helpers/Separator'
import { COLORS } from '@btime/constants'

const MarkdownEditor = ({ value, onChange, interpolations }) => {
  const [upload] = useUploadRequest()
  const [editor] = React.useState(() =>
    compose(
      ImagePlugin.extend(upload, { fullControl: false }), //
      LinkPlugin.extend,
      InterpolationPlugin.extend({ fullControl: false }),
      withReact,
      withHistory
    )(createEditor())
  )
  const initialValue = React.useMemo(() => deserializeMarkdown(value || ''), [])

  return (
    <Panel padding={0} radius={0.4} borderColor={COLORS.light5}>
      <Slate editor={editor} value={initialValue} onChange={compose(onChange, serializeMarkdown)}>
        <EditorContext size="small">
          <MarkdownControlBar editor={editor} interpolations={interpolations} />
          <Separator paddingV={0.6} paddingH={0.7}>
            <Editable onKeyDown={useEditorKeydown(editor)} renderElement={renderElement} renderLeaf={renderLeaf} />
          </Separator>
        </EditorContext>
      </Slate>
    </Panel>
  )
}

export default MarkdownEditor
